import AxiosProduct from '../store_product_api/axios_product_api'

const ModuleProduct = {
  state: {
    // Product Detail
    stateProductDetailData: [],
    // Add Product
    stateAddProduct: [],
    stateDetailTraceability: [],
    stateDirectdealRequest: []
  },
  mutations: {
    // Product Detail
    mutationsProductDetail (state, data) {
      state.stateProductDetailData = data
    },
    // Add Product
    mutationsAddProduct (state, data) {
      state.stateAddProduct = data
    },
    mutationsDetailTraceability (state, data) {
      state.stateDetailTraceability = data
    },
    mutationsDirectdealRequest (state, data) {
      state.stateDirectdealRequest = data
    }
  },
  actions: {
    // Product Detail
    async actionsProductDetail (context, access) {
      const dataProduct = await AxiosProduct.GetProductDetail(access)
      await context.commit('mutationsProductDetail', dataProduct)
    },
    async actionsAddProduct (context, access) {
      const response = await AxiosProduct.AddProduct(access)
      await context.commit('mutationsAddProduct', response)
    },
    async actionsGetDetailTraceability (context, access) {
      const response = await AxiosProduct.GetDetailTraceability(access)
      await context.commit('mutationsDetailTraceability', response)
    },
    async actionsDirectdealRequest (context, access) {
      const response = await AxiosProduct.DirectdealRequest(access)
      await context.commit('mutationsDirectdealRequest', response)
    }
  }
}

export default ModuleProduct
